import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import CategoryPanel from './CategoryPanel';
import '../../../content/css/CategoryPanel.css';

export default class CategoryPanelGroup extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            open: false
        };
    }

    handleToggle = () => {
        this.setState({ open: !this.state.open });
    }

    renderConcepts() {
        return this.props.categories.map(x =>
            <CategoryPanel
                categoryTheme={x}
                getCategoryTheme={this.props.getCategoryTheme}
                isAllowedToEdit={this.props.isAllowedToEdit}
                onEdit={this.props.onEdit}
            />
        );
    }

    render() {
        return (
            <div className="category-group">
                <div className="group-header" onClick={this.handleToggle}>
                    <span>{this.props.header}</span>
                    <div className="toggle">
                        {this.state.open && <Glyphicon glyph="chevron-up" />}
                        {!this.state.open && <Glyphicon glyph="chevron-down" />}
                    </div>
                </div>
                <div className={`content ${this.state.open ? "" : "inactive"}`}>
                    {this.renderConcepts()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/UserView/CategoryPanelGroup.js